import React, { useState, useEffect, useCallback } from 'react'
import { batch, useSelector } from 'react-redux'
import Portal from '../Portal/Portal.jsx'
import styles from './statistic-modal.module.scss'
import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg'
import SendStatisticStepOne from './SendStatisticStepOne.jsx'
import SendStatisticStepTwo from './SendStatisticStepTwo.jsx'
import SendStatisticStepThree from './SendStatisticStepThree.jsx'
import SendStatisticStepFour from './SendStatisticStepFour.jsx'
import Socket from '../../websocket/index.js'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.js'
import { billingStatus } from '../ProfileHeader/Services/utils.js'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { clearSurveyState, setSurveyStatusAction } from '../../redux/ui/ui.action.js'
import { useDispatch } from 'react-redux'
import { profilePaths } from '../../constants/constans.js'

export default function StatisticModal({ onClose }) {
  const [currentStep, setCurrentStep] = useState(1)
  const [pendingVacancyId, setPendingVacancyId] = useState(null)
  const surveyData = useSelector(({ ui }) => ui.surveyData)
  const route = useHistory()
  const dispatch = useDispatch()

  const setClosedOnStepOne = () => {
    sessionStorage.setItem('surveyClosedOnStepOne', 'true')
  }

  const handleStepChange = (step) => {
    setCurrentStep(step)
  }

  const handleClose = () => {
    if (currentStep === 1) {
      setClosedOnStepOne()
      onClose()
    } else if (currentStep === 2) {
      sendVacancySelection(null)
      setCurrentStep(4)
    } else if (currentStep === 3) {
      onClose()
    } else {
      onClose()
    }
  }

  const sendVacancySelection = useCallback((vacancyId) => {
    if (Socket.isReady) {
      Socket.emit('seafarer_survey.select_vacancy', { vacancy_id: vacancyId })
      if (vacancyId === null) {
        handleClose()
      }
    }
  }, [])
  const handleFoundNo = () => {
    handleStepChange(2)
  }

  const handleExploreServices = () => {
    if (currentStep === 2) {
      sendVacancySelection(null)
    }
    batch(() => {
      dispatch(setSurveyStatusAction(false))
      route.push(profilePaths.billing)
    })
  }

  const requestSurveyData = () => {
    if (Socket.isReady) {
      Socket.emit('seafarer_survey.get_survey', {})
    }
  }

  useEffect(() => {
    requestSurveyData()
  }, [])

  useEffect(() => {
    const target = document.body
    const htmlEl = document.documentElement
    // const bodyEl = document.body

    htmlEl.style.overflow = 'hidden'
    // bodyEl.style.overflow = 'hidden'

    disableBodyScroll(target)

    const closeOtherModals = () => {
      const backdrops = document.querySelectorAll('.MuiBackdrop-root')
      backdrops.forEach((backdrop) => {
        backdrop.click()
      })

      const popovers = document.querySelectorAll('[role="presentation"]')
      popovers.forEach((popover) => {
        if (popover.style.visibility !== 'hidden') {
          const closeButton = popover.querySelector('button[aria-label="close"]')
          if (closeButton) {
            closeButton.click()
          }
        }
      })

      const escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        keyCode: 27,
        bubbles: true,
        cancelable: true,
      })
      document.dispatchEvent(escapeEvent)
    }

    closeOtherModals()

    return () => {
      enableBodyScroll(target)
      htmlEl.style.overflow = 'auto'
      // bodyEl.style.overflow = 'auto'
    }
  }, [])

  useEffect(() => {
    if (currentStep === 4 && pendingVacancyId !== null) {
      sendVacancySelection(pendingVacancyId)
    }
  }, [currentStep, pendingVacancyId, sendVacancySelection])

  useEffect(() => {
    if (currentStep === 4) {
      setCurrentStep(1)
    }
  }, [surveyData])

  const renderCurrentStep = () => {
    if (surveyData && surveyData.no_surveys_found) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Survey Not Found</h3>
          <p>Currently, there are no available surveys for you.</p>
          <button
            onClick={onClose}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#43927C',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      )
    }

    switch (currentStep) {
      case 1:
        return (
          <SendStatisticStepOne
            surveyData={surveyData}
            onFoundYes={() => handleStepChange(3)}
            onFoundNo={handleFoundNo}
            onClose={handleClose}
          />
        )
      case 2:
        if (!billingStatus()) {
          return <SendStatisticStepFour onClose={onClose} isSkip={true} />
        }

        return (
          <SendStatisticStepTwo
            onExploreServices={handleExploreServices}
            onSkip={() => {
              sendVacancySelection(null)
              setCurrentStep(4)
            }}
          />
        )
      case 3:
        return (
          <SendStatisticStepThree
            surveyData={surveyData}
            pendingVacancyId={pendingVacancyId}
            setPendingVacancyId={setPendingVacancyId}
            onSend={() => {
              // selectedData => {
              // const vacancyId = selectedData.vacancy_id || null
              // setPendingVacancyId(vacancyId)
              handleStepChange(4)
            }}
            onSkip={() => {
              sendVacancySelection(null)
            }}
            onClose={() => {
              sendVacancySelection(null)
            }}
            onExploreServices={handleExploreServices}
          />
        )
      case 4:
        return <SendStatisticStepFour onClose={onClose} />
      default:
        return (
          <SendStatisticStepOne
            onFoundYes={() => handleStepChange(3)}
            onFoundNo={handleFoundNo}
            onClose={handleClose}
          />
        )
    }
  }

  useEffect(() => {}, [])

  return (
    <Portal>
      <div className={styles.statisticModalOverlay}>
        <div className={styles.statisticModal}>
          {renderCurrentStep()}
          {currentStep && (
            <button onClick={handleClose} className={styles['statisticModal__close-button']}>
              <CloseSvg width={20} height={20} color='#7B958D' />
            </button>
          )}
        </div>
      </div>
    </Portal>
  )
}
